<div class="sos-card">
  <div class="card-head">
    <div class="avatar">{{ initials }}</div>
    <div class="who">
      <span class="driver">{{ alert.driver }}</span>
      <span class="vehicle">{{ alert.vehicle }}</span>
    </div>
    <span class="severity">{{ 'SOS.SEVERITY' | translate }}</span>
  </div>

  <div class="location">
    <mat-icon svgIcon="warning" class="loc-icon"></mat-icon>
    <span>{{ alert.location }}</span>
  </div>

  <div class="time">{{ alert.occurrenceTime | dayjsDateTime }}</div>

  <div class="card-actions">
    @if (isClient ? alert.vehicleId : alert.eventId) {
    <button type="button" class="card-btn ghost" (click)="viewOnMap.emit()">
      {{ (isClient ? 'SOS.VIEW_MAP' : 'SOS.VIEW_DETAILS') | translate }}
    </button>
    }
    <button type="button" class="card-btn ack" (click)="acknowledge.emit()">
      <mat-icon svgIcon="check_circle"></mat-icon>
      <span>{{ 'SOS.ACKNOWLEDGE' | translate }}</span>
    </button>
  </div>
</div>
